import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Settings } from 'luxon';
import { EonUiComponentsAngularModule } from '@eon-ui/eon-ui-components-angular';
import { configureTranslateService } from './util/configure-translation';
import { AuthenticationService } from './service/authentication.service';
import { AppStateService } from './service/app-state.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        EonUiComponentsAngularModule,
    ],
    templateUrl: './app.component.html',
})
export class AppComponent {
    constructor(
        translateService: TranslateService,
        private authenticationService: AuthenticationService,
        private appStateService: AppStateService,
    ) {
        configureTranslateService(translateService);
        this.authenticationService.initAuthentication();
        Settings.defaultZone = this.appStateService.getSelectedTimezone();
    }
}
